export default input =>
  input
    ?.split('-')
    .filter(sub => !/^[A-Z]{2}$/.test(sub))
    .map(sub => sub.replace(/^0+/g, ''))
    .filter(sub => sub.length > 0)
    .join('-');
